
import { clear } from "@/lib/controls/values";
import { Control, ControlsTreeContext } from "@/types/controls";
import Vue from "vue";
import { Component, Prop, Inject } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon }
})
export default class IndicatorLight extends Vue {
  @Prop()
  path!: string;

  @Prop()
  control!: Control;

  stage: 1 | 2 = 1;

  increaseStage(event: MouseEvent) {
    if (this.stage === 1) {
      this.stage = 2;
      return;
    }

    if (this.stage === 2) {
      this.clearStyles(this.path, this.control, event.shiftKey);
      this.stage = 1;
    }
  }

  mouseIsHere = false;

  setMouseIsHere() {
    this.stage = 2;
    this.mouseIsHere = true;
  }

  setStageToOneWithDelay() {
    this.mouseIsHere = false;

    setTimeout(() => {
      if (!this.mouseIsHere) {
        this.stage = 1;
      }
    }, 300);
  }

  @Inject("context") readonly context!: ControlsTreeContext;

  clearStyles(path: string, control: Control, currentBreakpointOnly: boolean) {
    clear(path, control, this.context, currentBreakpointOnly);

    this.$emit("click");
  }
}
